<template>
  <div class="mains">
    <div class="campus">
      习题管理
      <span>></span>制作习题
    </div>
    <div class="xiaoqu moerduo">
      <el-row :gutter="24">
        <el-col :span="24">
          <div class="grid-content bg-purple scrollbarStyle" style="height: 85vh; overflow: auto">
            <el-dialog title="选择教材" :visible.sync="getBookLists" class="tj_jc">
              <div class="form_1 form_1_1">
                <el-form ref="forms" :model="forms" :rules="FormRules" label-width="5.20833vw">
                  <el-form-item label prop="name" class="wjj_mc quanbu_jc">
                    <div>
                      <div class="jc_fl">教材系列</div>
                      <div class="jc_11">教材</div>
                      <div class="sousuo sousuo_wjj jc_ss">
                        <span>教材名称：</span>
                        <el-input v-model="orgnames" @keyup.13.native="getThisBook" placeholder="请输入教材关键字进行查找"></el-input>
                        <el-button type="primary" class="buttons sousuo_wjj1" @click="getThisBook(groupId)">查 询</el-button>
                      </div>
                    </div>
                    <div class="jc_22">
                      <div class="quanbujiaocai">
                        <div :class="{ quanbujiaocai_2 :index == selectTypeIndex }" v-for="(item, index) in jiaocai_List" :key="index" @click="getThisBook(item.id,index)">
                          {{ item.name }}
                        </div>
                      </div>

                      <div class="jiaocai_1 jiaocai_1s jiao_tu">
                        <div v-if="jiaoyu1.length === 0">
                          <h3>该教材系列为空!</h3>
                        </div>
                        <div class="jiaocai" v-for="(item, index) in jiaoyu1" :key="index">
                          <el-radio-group v-model="chooseListAnswer" @change="xuanzhong(item)">
                            <div class="jiaocai_tu">
                              <el-radio class="is-checked0" :label="item.id">
                                <!-- <img :src="item.zuoshangjiao" class="zuoshangjiao" /> -->
                                <img :src="item.picurl" style="border-radius: 0.52083vw" />
                                <!-- <img :src="item.youxiajiao" style="float: right" class="youxiajiao" :class="item.youxiajiao ? '' : 'youxiajiao2'" /> -->
                              </el-radio>
                            </div>
                            <div class="jiaocai_zi">{{ item.name }}</div>
                          </el-radio-group>
                        </div>
                        <el-pagination class="fenye_1" background @size-change="handleSizeChanges" @current-change="handleCurrentChanges" :current-page="currentPages" :page-size="pageSizes"
                          layout="prev, pager, next, jumper" :total="totals">
                        </el-pagination>
                      </div>
                    </div>
                  </el-form-item>
                  <el-form-item class="queding jiaocai_queding">
                    <el-button type="primary" @click="queding">
                      确定
                    </el-button>
                    <el-button @click="quxiao">取消</el-button>
                  </el-form-item>
                </el-form>
              </div>
            </el-dialog>

            <div class="xiaoqu_1">制作习题</div>
            <p class="tishi">
              <i>
                <img src="@/assets/img/education-manage/campus/shenzhong.png" alt />
              </i> 此处为题包的新建页面，请您在此页面完善该题包的信息。
            </p>
            <el-form style="marginLeft: 18.75rem;">
              <el-form-item label="所属教材">
                <el-input v-model="form.name" style="width:750px"></el-input>
                <el-button style="backgroundColor:rgba(0, 166, 230, 1); color:white; marginLeft: 25px;" @click="getBookLists=true;referOrganzationList()">+ 选择教材</el-button>
              </el-form-item>
              <el-form-item label="选择标签">
                <el-cascader v-model="value" :options="littleNodeList" @change="handleChange" separator="-" :props="{label:'name', value:'name', children: 'values'}"></el-cascader>
              </el-form-item>
              <el-form-item label="题包名称">
                <el-input v-model="form.questionName" style="width:750px"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" style="marginLeft:70px;" v-if="Boolean(this.$route.query.id) == true" @click="editMessage()" round>提 交</el-button>
                <el-button type="primary" style="marginLeft:70px;" v-else @click="selfBuilt()" round>创建习题包</el-button>
                <!-- <router-link to="#">
                  <el-button size="medium" round style="marginLeft:20px;" @click="reassemblePack()">创建重组习题包</el-button>
                </router-link> -->
              </el-form-item>
            </el-form>

          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'schoolbook',
  data() {
    return {
      jiaocai_List: [],
      selectTypeIndex: 0,
      type: 0,
      chooseListAnswer: '',
      orgnames: '',
      orgnamess: '',
      jiaoyu: [],
      jiaoyu1: [],
      xz_jc: '',
      FormRules: {},
      xz_jc1: '',
      form: {
        name: '',
        region: '',
        namez: '',
        questionName: '',
      },
      pages: 1,
      pageSizes: 24,
      currentPage: 1,
      currentPages: 1,
      total: 0,
      totals: 0,
      forms: {
        name: '',
      },
      groupId: '',
      checkedNames: [],
      quanbujiaocai_s: true,
      addBookGroups: false,
      getBookLists: false,
      jczongshu0: '',
      jczongshu1: '',
      littleNodeList: [],
      value: [],
      littleNode: '',
      selection: '',
      questionPackId: '',
    };
  },
  watch: {},
  created() {
    this.getBookGoupList();
    this.getLittleNode();
    this.changeMessage();
    console.log(this.$route.query);
  },
  methods: {
    changeMessage() {
      this.form.name = this.$route.query.bookName;
      this.value= [this.$route.query.section.split('-')[0],Number(this.$route.query.section.split('-')[1])],
      this.form.questionName = this.$route.query.title;
      console.log(( this.$route.query.section.split('-')[0]));
    },
    queding() {
      this.getBookLists = false;
      this.form.name = this.form.namez;
    },
    //编辑习题信息
    editMessage() {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let orgid = window.sessionStorage.getItem('orgid');
      // console.log(this.miniid,"111");
      let pro = this.$http({
        url: '/edu/exercise-pack/base/' + this.$route.query.id + '/upd',
        method: 'POST',
        data: {
          bookId: this.xz_jc,
          section: this.littleNode,
          title: this.form.questionName,
        },
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro.then((res) => {
        this.$router.push({ path: 'exerciselibrary' });
        return this.$message.success('修改成功！');
      });
    },
    //获取机构类表
    referOrganzationList() {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let orgid = window.sessionStorage.getItem('orgid');
      // console.log(this.miniid,"111");
      let pro = this.$http({
        url: '/edu/book/getGroupList/' + orgid,
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro.then((res) => {
        console.log(res, '查询机构');
        this.getThisBook(res.data.data[0].id);
        this.jiaocai_List = res.data.data;
        console.log(this.data, '这是数据');
      });
    },
    //获取图书列表
    getThisBook(id, index) {
      console.log(id, 'aaa');
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let orgid = window.sessionStorage.getItem('orgid');
      let pro = this.$http({
        url: '/edu/book/books/' + orgid + '/' + id,
        params: {
          bookName: this.orgnames,
          page: this.pages,
          pageSize: this.pageSizes,
        },
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro.then((res) => {
        console.log(res, '查询了机构');
        if (res.data.code === 0) {
          this.groupId = id;
          this.selectTypeIndex = index;
          this.jiaoyu1 = res.data.data;
          this.jczongshu0 = res.data.data.length;
          this.totals = res.data.size;
          this.chooseListAnswer = '';
        }
      });
    },
    //获取小节列表
    getLittleNode() {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let orgid = window.sessionStorage.getItem('orgid');
      // console.log(index,"111");
      let pro = this.$http({
        url: '/edu/exercise/section',
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro.then((res) => {
        console.log(res, '查询了小结');
        this.littleNodeList = res.data.data;
      });
    },

    quxiao() {
      if (this.addBookGroups) {
        this.addBookGroups = false;
      }
      if (this.getBookLists) {
        this.getBookLists = false;
      }
    },
    xuanzhong(index) {
      index.selected = !index.selected;
      if (index.selected === true) {
        this.xz_jc = index.id;
        this.form.namez = index.name;
      }
      console.log(index.selected, '哈哈哈');
      console.log(this.xz_jc);
    },
    //自建习题包
    selfBuilt() {
      if (this.selection === '' && this.form.questionName === '') {
        return this.$message.error('请正确填写信息');
      }
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let orgid = window.sessionStorage.getItem('orgid');
      let pro = this.$http({
        url: '/edu/exercise-pack/self-built/save',
        method: 'POST',
        data: {
          orgId: orgid,
          bookId: this.xz_jc,
          section: this.littleNode,
          title: this.form.questionName,
        },
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro.then((res) => {
        console.log(res, '结果');
        if (res.data.code === 0) {
          this.questionPackId = res.data.data.questionPackId;
          this.$router.push({ path: '/bigquestionlist', query: { id: this.questionPackId, bookid: this.xz_jc, littleNode: this.littleNode } });
        }
      });
    },
    //重组习题包
    reassemblePack() {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let orgid = window.sessionStorage.getItem('orgid');
      let pro = this.$http({
        url: '/edu/exercise-pack/restructure/save',
        method: 'POST',
        data: {
          orgId: orgid,
          bookId: this.xz_jc,
          section: this.littleNode,
          title: this.form.questionName,
        },
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro.then((res) => {
        if (ras.data.code === 0) {
          this.$router.push('/bigquestionlist');
        }
      });
    },
    // 查询教材
    getBookGoupList() {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let orgid = window.sessionStorage.getItem('orgid');
      let pro = this.$http({
        url: '/edu/bookgroup/getBookGoupList',
        method: 'POST',
        data: {
          orgid: orgid,
          name: this.orgnames,
          page: this.page,
          pageSize: this.pageSize,
        },
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          // console.log(result.data)
          if (result.data.code !== 0) {
            return this.$message.error(result.data.message);
          }
          this.jiaoyu = result.data.data;
          this.jczongshu1 = result.data.data.length;
          this.jiaoyu.forEach(function (c) {
            if (c.type === 5) {
              c.zuoshangjiao = require('@/assets/img/textbook-manage/schoolbook/wenjianjia.png');
              c.youxiajiao = false;
            }
            if (c.type === 0) {
              c.zuoshangjiao = require('@/assets/img/textbook-manage/schoolbook/guanfang.png');
              c.youxiajiao = require('@/assets/img/textbook-manage/schoolbook/diandu.png');
            }
            if (c.type === 1) {
              c.zuoshangjiao = require('@/assets/img/textbook-manage/schoolbook/zizhi1.png');
              c.youxiajiao = require('@/assets/img/textbook-manage/schoolbook/zizhi.png');
            }
          });
          if (this.jiaoyu === undefined || this.jiaoyu === null) {
            this.total = 0;
          } else {
            this.total = result.data.size;
          }
        })
        .catch((err) => {
          // console.log(err)
          return this.$message.error('查询教材失败：' + err);
        });
    },
    handleChange(value) {
      console.log(value);
      this.littleNode = value[0] + '-' + value[1];
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.page = 1;
      this.currentPage = 1;
      this.getBookGoupList();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getBookGoupList();
    },
    handleSizeChanges(val) {
      this.pageSizes = val;
      this.pages = 1;
      this.currentPages = 1;
      this.getThisBook();
    },
    handleCurrentChanges(val) {
      this.pages = val;
      this.getThisBook();
    },
  },
};
</script>

<style lang="less" scpoed>
.clear {
  clear: both;
}
.el-pagination__editor.el-input .el-input__inner {
  width: 25px !important;
}
.mains .xiaoqu .grid-content .tj_jc {
  .quanbu_jc {
    .el-form-item__content {
      margin-left: 0 !important;
    }
  }
  .el-dialog {
    width: 1300px !important;
    height: 850px;
    top: 50%;
  }
  .el-dialog__header {
    width: 1240px !important;
    .el-dialog__title {
      font-size: 22px;
      padding-left: 28px;
    }
    .el-dialog__title:before {
      height: 22px;
      top: 26px;
      left: 40px;
    }
    .el-dialog__headerbtn {
      right: 40px;
    }
  }
  .jc_11 {
    float: left;
    margin-left: 185px;
    font-size: 18px;
  }
  .jc_fl {
    float: left;
    font-size: 20px;
    color: #333;
    font-weight: bold;
    margin-left: 28px;
  }
  .jc_ss {
    margin: 0;
    .el-input {
      input {
        width: 220px;
      }
    }
  }

  .jc_22 {
    clear: both;
    margin-left: -10px;
    .quanbujiaocai {
      margin-top: 15px;
      float: left;
      div {
        width: 212px;
        height: 50px;
        line-height: 50px;
        font-size: 18px;
        color: #999;
        background: #efefef;
        border-radius: 5px;
        margin: 10px 0 0 0;
        padding-left: 28px;
      }
      div:hover {
        color: #fff;
        background: #00a6e6;
      }
      .quanbujiaocai_2 {
        color: #fff;
        background: #00a6e6;
      }
    }

    .jiao_tu {
      .jiaocai_zi {
        margin-top: 5px;
        line-height: 17px;
        height: 49px;
      }
      .fenye_1 {
        margin: 0 !important;
      }
    }

    .jiaocai {
      margin: 30px 0px 0 30px !important;
      .jiaocai_tu {
        width: 162px !important;
        height: 206px !important;
        img {
          width: 150px !important;
          height: 190px !important;
          margin: 13px 0 0 -4px;
        }
        .zuoshangjiao {
          position: absolute;
          top: -8px;
          left: -5px;
          width: 50px !important;
          height: 25px !important;
          z-index: 999 !important;
        }
        .youxiajiao {
          position: absolute;
          right: -3px;
          bottom: 4px;
          width: 48px !important;
          height: 18px !important;
        }
      }
      .jiaocai_zi {
        width: 162px;
      }
      .jiaocai_tu {
        .is-checked {
          .el-checkbox__input {
            background: none !important;
          }
        }
      }
      .el-radio {
        position: absolute;
        // top: -14px;
        // right: -6px;
        z-index: 9999;
        .el-radio__input {
          width: 22px;
          height: 22px;
          float: right;
          background: url(../../../assets/img/textbook-manage/schoolbook/weixuan.png) no-repeat !important;
          background-size: 22px 22px !important;
          .el-radio__inner {
            width: 0;
            height: 0;
            border: none;
          }
          .el-radio__inner::after {
            width: 22px;
            height: 22px;
            top: -12px;
            left: 0px;
            border: none;
            background: url(../../../assets/img/textbook-manage/schoolbook/xuanzhong.png) !important;
            background-size: 22px 22px !important;
          }
          input {
            width: 0;
          }
        }
        .el-radio__input.is-checked .el-radio__inner::after {
          transform: none;
        }
      }
    }
  }
  .form_1_1 {
    .jiaocai_queding {
      margin-top: 15px;
      .el-form-item__content {
        margin-left: 216px !important;
      }
      .el-button--primary {
        width: 240px;
        height: 44px;
        border-radius: 34px;
        background: #0094ce;
        font-size: 20px;
      }
      .el-button--primary:hover {
        background: #0094ce;
      }
      .el-button--default {
        width: 240px;
        height: 44px;
        border-radius: 34px;
        background: rgba(242, 242, 242, 0.8);
        border: none;
        box-shadow: 2px 2px 6px rgba(234, 234, 234, 0.3);
      }
    }
  }
}
.tishi {
  width: 100%;
  top: 60px;
  left: 0;
  color: #f87e2e;
  background-color: #feefe5;
}
.tishi i {
  margin-left: 3.4375rem /* 55/16 */;
}
.wjj_mc {
  .el-form-item__label {
    padding: 0 !important;
    margin-left: 5px;
  }
  .el-form-item__content {
    margin-left: 140px !important;
  }
  .wuzi {
    left: -125px !important;
  }
}
</style>
